import React from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { GET_DISHTAGS } from '../../constants';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '../common/Input';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { updatetag, deletetag } from '../../actions/tags';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const Tags = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  const [open, setOpen] = React.useState(false);
  const [tagid, setTagid] = React.useState(0);
  const [errors, setErrors] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const [tableKey, setTableKey] = React.useState(1);
  const [dishtag, setTag] = React.useState({ tagName: "" })
  const handleClose = () => {
    setOpen(false);
  };
  const onDelete = (rowdata) => {
    setLoading(true);
    deletetag(rowdata.tagId, (message, isError) => {
      const method = isError ? 'error' : 'success';
      console.log("message---->tage->.>", message)
      toast[method](message);
      setLoading(false);
      // console.log("method",method);
      if (method === "success") {
        setTableKey(tableKey + 1);
      }
    })
  }
  const onEdit = (rowdata) => {
    setTagid(rowdata.tagId);
    setTag({ tagName: rowdata.tagName });
    setOpen(true);
    //console.log(rowdata) ;
  }

  const schema = [
    {
      field: 'tagName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'tagName is required.',
    },
  ];
  const validator = new FormValidator(schema);
  const handleChange = (key, e) => {
    setTag({
      tagId: tagid,
      [key]: e.target.value,
    })
  }
  const updateTag = () => {
    const err = validator.validate({ ...dishtag });
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    updatetag(dishtag, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      // console.log("method",method);
      if (method === "success") {
        handleClose();
        setTableKey(tableKey + 1);
      }
    })
  };

  return (
    <div>
      <Table
        key={tableKey}
        tableConfig={config}
        data={data}
        onDelete={onDelete}
        onEdit={onEdit}
        apidata="tags"
        //globalSearch={true}
        // filtering={false}
        url={GET_DISHTAGS}
      />
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Update Tag
        </DialogTitle>
        <DialogContent dividers>
          <Card className={classes.root}>
            <CardContent>
              <TextField
                label="Tag Name"
                name="tagName"
                placeholder="Update Tag name"
                onChange={(e) => handleChange('tagName', e)}
                classes={{ root: classes.input }}
                value={dishtag.tagName}
                error={errors && errors.tagName && errors.tagName.isInvalid}
                helperText={errors && errors.tagName && errors.tagName.isInvalid && errors.tagName.message}
              />
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button autoFocus size="small" label="Add" onClick={updateTag}>
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
};
export default Tags;
